export const ADMIN_ROLES = ["ADMIN", "SUPER_ADMIN"];
export const STAFF_ROLES = ["PETUGAS", "VERIFIKATOR", "PIMPINAN", "ADMIN", "SUPER_ADMIN"];
const STAFF_ROLES_WITHOUT_SUPER = ["PETUGAS", "VERIFIKATOR", "PIMPINAN", "ADMIN"];

export const isAdminRole = (role) => ADMIN_ROLES.includes(role);
export const isStaffRole = (role) => STAFF_ROLES.includes(role);
export const isSuperAdminRole = (role) => role === "SUPER_ADMIN";

export const expandAllowedRoles = (roles) => {
  const set = new Set(roles);

  if (roles.includes("ADMIN")) {
    ADMIN_ROLES.forEach((r) => set.add(r));
  }

  if (roles.some((r) => STAFF_ROLES_WITHOUT_SUPER.includes(r))) {
    STAFF_ROLES.forEach((r) => set.add(r));
  }

  return [...set];
};
